/*global googletag, window*/

/**
 * MediaInit
 *
 * @class MediaInit
 * @param {initAds} callback to initialize ads after initialize library
 */

const initializeAdsLibrary = function() {
  window.ads_library.initialized = true;
  //in case gpt.js is completely blocked, googletag.pubads() is not set up, assign an object to this function so that does not cause js error
  if (!window.googletag || !googletag.apiReady) {
    googletag.pubads = function() {
      return {
        refresh: function() {},
        setTargeting: function() {},
        setCategoryExclusion: function() {}
      };
    };
    googletag.display = function() {};
    $('.ads').hide();
    $('.ad-srp-inline').hide();
    $('.facet-bar').attr('data-offset-top', '48px');
    window.pbjs = function() {
      return {
        refreshAds: function() {}
      };
    };
    return false;
  }
  return true;
};

const MediaInitialze = function () {
  return new Promise(function(resolve, reject) {
    if (!initializeAdsLibrary()) {
      reject(new TypeError('No Ad Library.'));
    }

    googletag.cmd.push(function () {
      $('.ads').each(function () {
        googletag.display(this.getAttribute('id'));
      });

      if (window.Krux) {
        googletag.pubads().setTargeting('ksg', window.Krux.segments);
        googletag.pubads().setTargeting('kuid', window.Krux.user);
      }

      setTimeout(function () {
        resolve();
      }, 20);
    });
  });
};

export const MediaInit = MediaInitialze;



// WEBPACK FOOTER //
// ./shared_critical/media/init.js